import rootService from 'core/services.root';

export default rootService({
    deleteCoverage: ['DELETE', '/medical-coverage/delete/:id'],
    getCoverage: ['GET', '/medical-coverage/:id'],
    getCoverageList: ['GET', '/medical-coverage/all'],
    postCoverage: ['POST', '/medical-coverage/store'],
    putCoverage: ['PUT', '/medical-coverage/update/:id']
});
